import React from 'react';
import createDecorator from 'final-form-focus';
import { Form, FormProps } from 'react-final-form';
import setTouched from 'mutators/setTouched';
import { Decorator } from 'final-form';
import setModifiedSinceLastBlur from 'mutators/setModifiedSinceLastBlur';

const focusOnErrors = createDecorator();

interface IProps<FormValues, InitialFormValues>
  extends FormProps<FormValues, InitialFormValues> {}

const BaseReactFinalForm = <FormValues, InitialFormValues>(
  props: IProps<FormValues, InitialFormValues>
) => {
  return (
    <Form
      decorators={[focusOnErrors as Decorator<any, any>]}
      mutators={{
        setTouched,
        setModifiedSinceLastBlur
      }}
      {...props}
    />
  );
};

export default BaseReactFinalForm;
